import { MilestoneLessonsModel, MilestoneModel } from '@/models/journey/journey';

export class JourneySerializer {

    private static INSTANCE = new JourneySerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeMilestones(payload: any) {
        const payloadItems = payload.milestones || [];
        const milestonesList: MilestoneModel[] = [];
        payloadItems.forEach((item: any) => {
            const milestone: MilestoneModel = {
                gradeId: item.grade_id,
                milestoneId: item.milestone_id,
                competencyCount: item.competency_count,
                computedEtlSecs: item.computed_etl_secs,
                gradeName: item.grade_name,
                gradeSeq: item.grade_seq,
                subjectCode: item.tx_subject_code,

            };
            milestonesList.push(milestone);
        });
        return milestonesList;
    }


    public normalizeMilestoneLessons(payload: any) {
         const payloadLessons = payload.lessons || [];
         const lessonItems: MilestoneLessonsModel[] = [];
         payloadLessons.forEach((item: any) => {
             const lesson: MilestoneLessonsModel = {
                unitId: item.unit_id,
                unitTitle: item.unit_title,
                domainCode: item.tx_domain_code,
                domainName: item.tx_domain_name,
                domainSeq: item.tx_domain_seq,
                lessonId: item.lesson_id,
                lessonTitle: item.lesson_title,
                compCode: item.tx_comp_code,
                compName: item.tx_comp_name,
                compDisplayCode: item.tx_display_code,
             };
             lessonItems.push(lesson);
         });
         return lessonItems;
    }


}

export const journeySerializer = JourneySerializer.instance;
